export const GLOSSARY_IMAGE_URL = "https://vid.typingclub.com/";
